'use strict';
function dateStringToDate(date) {
  var split = date.split('/');
  var year = +split[2]; //make integer
  if(year < 100){
    year += 2000;
  }
  var month = +split[1] - 1; //make integer and zero indexed
  var day = +split[0]; //make integer
  return new Date(year, month, day);
}

export default class {
	/*@ngInject*/
	constructor($http, JSONToCSVConvertor){
		this.$http = $http;
		this.loaded = false;
		this.loadsRequired = 2;
		this.JSONToCSVConvertor = JSONToCSVConvertor;
		this.filteredTimesheets = [];
	}

	$onInit(){

	    this.$http.get('/api/tutors').then(res => {
	      this.tutors = res.data;
	      this.lowerLoad();
	    })

	    this.$http.get('/api/timesheets').then(res => {
	      this.timesheets = res.data;
	      this.lowerLoad();
	    })
	}

	createCSV(timesheets){
		this.JSONToCSVConvertor(timesheets, 'Total_Hours_Per_Tutor', true);
	}

	lowerLoad(){
		this.loadsRequired--;

		if(this.loadsRequired == 0){
			this.loaded = true;
		}
	}

 	tutorName(tutorID){
		const tutor = this.tutors.find(tutor => tutor.tutorID === tutorID);
		if(!tutor){
			return ''
		}
		return tutor.nameFirst + ' ' + tutor.nameLast;
	}


 	create(){

  	var filtered = this.timesheets.map(timesheet => timesheet);

  	if(this.startDate){
      filtered = filtered.filter(timesheet => {
        const tsDate =  dateStringToDate(timesheet.weekEnding)

        return this.startDate.getTime() < tsDate.getTime();
      })
    }

    if(this.endDate){
      filtered = filtered.filter(timesheet => {
        const tsDate =  dateStringToDate(timesheet.weekEnding)

        return this.endDate.getTime() > tsDate.getTime();
      })
    }

    //attach a tutor name to the array
    filtered = filtered.map(timesheet => {
    	timesheet.tutorName = this.tutorName(timesheet.tutorID);

    	return timesheet
    })

    var newArr = [];

    filtered.forEach(timesheet => {
    	const found = newArr.findIndex(news => news.tutorName === timesheet.tutorName);

    	if(found !== -1){
    		newArr[found].hours += timesheet.hours;
    		return
    	}
    	//else it doesn't exist and we can add it to the array

    	newArr.push({tutorName: timesheet.tutorName, hours: timesheet.hours})
    })


    //sort the timesheets, most recent displayed highest
    newArr = newArr.sort((a,b) => {
        var nameA = a.tutorName.toUpperCase(); // ignore upper and lowercase
		var nameB = b.tutorName.toUpperCase(); // ignore upper and lowercase
		if (nameA < nameB) {
			return -1;
		}
		if (nameA > nameB) {
			return 1;
		}

		// names must be equal
		return 0;
    })

  	this.filteredTimesheets = newArr;
  }

}


// WEBPACK FOOTER //
// ./client/app/reports/total-hours-range/total-hours-range.controller.js